var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDivide = function SvgDivide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6h11v1.9h-11ZM7 3.83a1.44 1.44 0 0 1-1-.39 1.41 1.41 0 0 1-.42-1.07A1.39 1.39 0 0 1 6 1.3a1.5 1.5 0 0 1 2 0 1.39 1.39 0 0 1 .42 1.07A1.41 1.41 0 0 1 8 3.44a1.44 1.44 0 0 1-1 .39Zm0 9.27a1.45 1.45 0 0 1-1-.4 1.39 1.39 0 0 1-.42-1.07A1.41 1.41 0 0 1 6 10.56a1.53 1.53 0 0 1 2 0 1.41 1.41 0 0 1 .42 1.07A1.39 1.39 0 0 1 8 12.7a1.45 1.45 0 0 1-1 .4Z"
  })));
};

export default SvgDivide;